module.exports = __webpack_public_path__ + "img/norcott_b2.5279425a.jpg";